/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import ExpandableBlock from '../ExpandableBlock';
import Header from './Header';
import Paper from '../Paper';
import styles from './index.styl';

@CSSModules(styles, { allowMultiple: true })
export default class ExpandableListItem extends Component {
  static propTypes = {
    children: PropTypes.any,
    expandableBlockClassName: PropTypes.string,
    className: PropTypes.string,
    header: PropTypes.shape({
      icon: PropTypes.node,
      title: PropTypes.string,
      subtitle: PropTypes.string,
      note: PropTypes.any,
    }),
    opened: PropTypes.bool,
    locked: PropTypes.bool,
    hasCustomMarker: PropTypes.bool,
    description: PropTypes.string,
    progress: PropTypes.number,
  };

  state = {
    showDescription: false,
  };

  handleOpenDescription = e => {
    e.stopPropagation();
    this.setState({ showDescription: true });
  };

  handleHideDescription = e => {
    e.stopPropagation();
    this.setState(prevState => ({
      showDescription: !prevState.showDescription,
    }));
  };

  render() {
    const {
      children,
      className,
      header,
      opened,
      locked,
      hasCustomMarker,
      progress,
      expandableBlockClassName,
      ...other
    } = this.props;

    const {
      icon,
      title,
      subtitle,
      note,
      description,
      list,
      reverseTitle,
      expirationStatus,
    } = header;

    const { showDescription } = this.state;
    const closeDescription = showDescription
      ? this.handleHideDescription
      : null;

    const expandableHeader = (
      <Header
        progress={progress}
        icon={icon}
        title={title}
        subtitle={subtitle}
        locked={locked}
        note={note}
        status={expirationStatus}
        description={description}
        reverseTitle={reverseTitle}
        openPopover={this.handleOpenDescription}
        closePopover={closeDescription}
        showPopover={showDescription}
        list={list}
      />
    );

    return (
      <div className={className} styleName="root" {...other}>
        <Paper overflowVisible={!!description}>
          <ExpandableBlock
            opened={opened}
            locked={locked}
            hasCustomMarker={hasCustomMarker}
            content={{
              head: expandableHeader,
              body: children,
            }}
            icon="arrow-down"
            className={expandableBlockClassName}
          />
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ExpandableListItem/index.jsx